module.exports = __webpack_public_path__ + "img/LMI_GoToMeeting_Orange_HEX.878ad892.png";